module.exports = __webpack_public_path__ + "img/knus_gallery4.386f6f3d.jpg";